module.exports = __webpack_public_path__ + "media/images/front/brands/atelier/atelier_3-7bbd8ac257d369be1a051204a5c1d21a.jpg";